<template>
  <div class="hidden md:inline-block">
    <DesktopFilters v-model="filters" :hub="props.hub" />
  </div>
  <div class="md:hidden">
    <MobileFilters v-model="filters" :hub="props.hub" />
  </div>
</template>

<script setup lang="ts">
import { MobileFilters } from './_components/mobile-filters';
import { DesktopFilters } from './_components/desktop-filters';
import { HubDto } from '~/api/hubs';
import { HubFilters } from '~/pages/_components/hub-details/_types';

type Props = {
  hub: HubDto;
};
const props = defineProps<Props>();

const filters = defineModel<HubFilters>({ required: true });
</script>
